<app-star-layer-overlay *ngIf="showStarLayer"></app-star-layer-overlay>
<!-- Gradient definition for circular progress (used in stroke) -->
<svg aria-hidden="true" style="position: absolute; width: 0; height: 0;">
  <defs>
    <linearGradient id="smartSuggestionsProgressGradient" x1="60%" y1="50%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#8590C8"/>
      <stop offset="50%" stop-color="#ADAACE"/>
      <stop offset="100%" stop-color="#7174AB"/>
    </linearGradient>
  </defs>
</svg>
<mat-sidenav-container class="verification-sidenav-container">
  <mat-sidenav
    #suggestionSidenav
    [mode]="'over'"
    position="end"
    [disableClose]="true"
    [fixedInViewport]="true"
    [fixedTopGap]="0"
    [fixedBottomGap]="0"
    class="verification-sidenav"
    [ngClass]="{'p-0': sidenavContentType === 'tax-setup'}"
  >
    <div class="sidenav-top-bar"
      [ngClass]="{'max-[991px]:mx-[16px]': sidenavContentType === 'tax-setup'}">
      <app-auto-registration-top-bar
        [logoSrc]="'assets/img/glameraTradeMarkLogo2.png'"
        [logoWidth]="132"
        [mobileLogoWidth]="110"
        [languageColor]="'#000'"
        (watchVideo)="onOpenVideo()"
      ></app-auto-registration-top-bar>
    </div>
    <div class="sidenav-content sidenav-content-after-topbar" fxLayout="column" fxLayoutAlign="start stretch">
      <ng-container *ngIf="sidenavContentType === 'business-details'">
        <app-business-details-step
          #businessDetailsCmp
          [showSkip]="false"
          [titleKey]="'Business_Details_Form_Title'"
          [descriptionKey]="'Complete_business_details_description'"
          [submitLabelKey]="'Confirm'"
          [previousLabelKey]="'Cancel'"
          [showActions]="false"
          (next)="onBusinessDetailsSuccess()"
          (previous)="onBusinessDetailsCancel()"
        ></app-business-details-step>
      </ng-container>
      <ng-container *ngIf="sidenavContentType === 'working-hours'">
        <app-working-hours-step
          #workingHoursCmp
          [showSkip]="false"
          [titleKey]="'Working_Hours_Form_Title'"
          [descriptionKey]="'Set_working_hours_description'"
          [submitLabelKey]="'Confirm'"
          [previousLabelKey]="'Cancel'"
          [sidenavMode]="true"
          [showActions]="false"
          (next)="onWorkingHoursSuccess()"
          (previous)="onWorkingHoursCancel()"
        ></app-working-hours-step>
      </ng-container>
      <ng-container *ngIf="sidenavContentType === 'add-employees'">
        <app-add-employees
          #addEmployeesCmp
          [titleKey]="'Add_Employees'"
          [descriptionKey]="'Add_employees_description_sidenav'"
          [submitLabelKey]="'Confirm'"
          [cancelLabelKey]="'Cancel'"
          [showActions]="false"
          [registrationCycleLogId]="sidenavRegistrationCycleLogId"
          (confirm)="onAddEmployeesSuccess()"
          (cancel)="onAddEmployeesCancel()"
        ></app-add-employees>
      </ng-container>
      <ng-container *ngIf="sidenavContentType === 'add-services'">
        <app-add-services
          #addServicesCmp
          [titleKey]="'Add_Services'"
          [descriptionKey]="'Add_services_description'"
          [submitLabelKey]="'Confirm'"
          [cancelLabelKey]="'Cancel'"
          [showActions]="false"
          (confirm)="onAddServicesSuccess()"
          (cancel)="onAddServicesCancel()"
        ></app-add-services>
      </ng-container>
      <ng-container *ngIf="sidenavContentType === 'tax-setup'">
        <app-tax-setup
          #taxSetupCmp
          [titleKey]="'Tax_setup'"
          [descriptionKey]="'Tax_setup_description'"
          [submitLabelKey]="'Confirm'"
          [cancelLabelKey]="'Cancel'"
          [registrationCycleLogId]="sidenavRegistrationCycleLogId"
          [showActions]="false"
          (confirm)="onTaxSetupSuccess()"
          (cancel)="onTaxSetupCancel()"
        ></app-tax-setup>
      </ng-container>
    </div>
    <div
      class="verification-sidenav-footer"
      *ngIf="sidenavContentType"
      fxLayout="row"
      fxLayoutAlign="stretch center"
    >
      <button
        type="button"
        class="smart-action-btn prev-btn d-flex align-items-center justify-content-center"
        fxFlex="1 1 0"
        (click)="onSidenavCancel()"
      >
        {{ 'Cancel' | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        class="smart-action-btn submit-btn"
        fxFlex="1 1 0"
        type="button"
        [disabled]="sidenavConfirmDisabled"
        (click)="onSidenavConfirm()"
      >
        {{ 'Confirm' | translate }}
        <span class="btn-spinner-icon" *ngIf="sidenavConfirmLoading"></span>
      </button>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="smart-suggestions-container">
      <div class="top-bar">
        <app-auto-registration-top-bar
          [logoWidth]="160"
          [mobileLogoWidth]="120"
          (watchVideo)="onOpenVideo()"
        ></app-auto-registration-top-bar>
      </div>

      <div class="flex items-center justify-between mt-[14px] min-[991px]:mt-[38px] mb-[24px] min-[991px]:mb-[48px]">
        <h1 class="font-[600] text-[12px] min-[991px]:text-[32px] text-[#000]">
          {{ "Get_Personalized_Smart_Suggestions" | translate }}
        </h1>
        <button
          *ngIf="!allStepsCompleted"
          type="button"
          class="complete-later-btn"
          (click)="onClose()"
          matTooltipPosition="above"
          [matTooltip]="'close_and_start_your_business' | translate"
        >
          {{ "Complete_Later" | translate }}
        </button>
      </div>

      <div class="main-content-row" fxLayout="row wrap">
        <div class="main-content-col main-content-left" fxFlex="100" fxFlex.gt-md="50">
          <div class="welcome-banner " *ngIf="!phasesLoading; else welcomeBannerSkeleton">
            <div class="flex items-start justify-between">
              <div>
                <!-- greeting -->
                <h2 class="text-[12px] min-[991px]:text-[20px] text-[#fff] font-[700] min-[991px]:mb-[8px] mb-[4px]">
                  {{ "Welcome" | translate }} {{ userName }}! 🎉
                </h2>
                <!-- progress-text -->
                <p class="text-[10px] min-[991px]:text-[16px] text-[#fff] font-[400]">
                  {{ progressCurrent }} {{ "of" | translate }} {{ progressTotal }}
                  {{ "steps_done" | translate }}.
                  <span *ngIf="progressCurrent < progressTotal" 
                    class="text-[10px] min-[991px]:text-[16px] text-[#fff] font-[400]">
                    {{ "Complete_your_profile" | translate }}
                  </span>
                </p>
              </div>
              
              <div class="spinner-container">

                <div class="spinner-wrapper">
                  <!-- Background track -->
                  <mat-progress-spinner
                    mode="determinate"
                    [value]="100"
                    [diameter]="spinnerDiameter"
                    [strokeWidth]="spinnerStrokeWidth"
                    class="spinner-track">
                  </mat-progress-spinner>

                  <!-- Progress arc -->
                  <mat-progress-spinner
                    mode="determinate"
                    [value]="progressPercent"
                    [diameter]="spinnerDiameter"
                    [strokeWidth]="spinnerStrokeWidth"
                    class="spinner-progress">
                  </mat-progress-spinner>
                </div>


                <div class="spinner-text">
                  {{ progressCurrent }}<span class="spinner-text-slash">/</span>{{ progressTotal }}
                </div>

              </div>
            </div>
          </div>

          <ng-template #welcomeBannerSkeleton>
            <div class="welcome-banner welcome-banner-skeleton">
              <div
                class="banner-content"
                fxLayout="row wrap"
                fxLayoutAlign="space-between center"
                fxLayoutGap="16px"
              >
                <div class="welcome-skeleton-text">
                  <div class="skeleton-line skeleton-line-primary"></div>
                  <div class="skeleton-line skeleton-line-secondary"></div>
                </div>
                <div class="welcome-skeleton-circle"></div>
              </div>
            </div>
          </ng-template>
      
          <div class="steps-section">
            <h3 class="section-title">{{ "Complete_Account" | translate }}</h3>
            <div >
              <div
                *ngFor="let item of completeAccountItems; let isLast = last"
                class="suggestion-card"
                [class]="isLast ? '' : 'mb-[12px] min-[991px]:mb-[24px]'"
              >
                <div class="card-left">
                  <span class="sparkle-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <rect width="18" height="18" fill="url(#pattern0_15301_6575)"/>
                      <defs>
                        <pattern id="pattern0_15301_6575" patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlink:href="#image0_15301_6575" transform="scale(0.0078125)"/>
                        </pattern>
                        <image id="image0_15301_6575" width="128" height="128" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAFJ9JREFUeJztnXt8VNW1x3/rzGSCJqGAWiv1WT8tKkL1trbVtrdgfdF7VZKZY+YRlKs1YLUUkgmI1jrXXoUwMwnGRwVfKElm4smAgh9Q0Ypa0Na21oIo13ttayvpbfFFJoVkZs66fyTpBzEz55x9zklm9Hz/nFlr75Xs3+yzz36sDTg4ODg4ODh8GqGxDuDTQkCOnU+MJQz8C4B+AFslwk87lPCusYzLEcAo4PdGryaiewBIh3y1D8QXJZSmF8ciLsARgO3U1bQek5NybwKoGNGAsDOL489QlMtyoxvZIIcq0sFiVCk7D/kaHwAYp5epf75w9CL6KI4AbIaZAjrMQrYHkgfnEWAjfl/8HAJv07Ij0D/GDWQ/98CGJb2jEdfBOD2AjRBY1y+bwYcf8Lir7Y5nJBwB2MTcuZFxAGr1e/DltgVTAEcANjHQV+UHcIReewbODXhjp9gY0og4ArABWY54mPkGg25EQMSOeArhCMAG3Ki8HsAXjfox4bKAHDvfhpDy4rwFWIzfF51BoC0A3IJF9GRJOktRGt6xMq58OD2Ahfi98TMJtB7ijQ8Ax7hZ3SzLbUdZFVchHAFYRK0vNouItwKYoGGa0VHcNLc68Is6uXmK+cgK4zwCTDJ3duuEfnfuFgDXQcf/kwgLmfF1AHpmCPuY+YbxR4z/2erV8/QIxzCOAAQJ1TQfy5JrHgPXQO/rHuH5KVPTM9961TMx4/LsBPA5ndW9CWClVO5p7+hYsE8w5DwhOegmFGobzwOZGjDXMTATxh6he9hN30gmG/8MAMGa+EyW+AkAHgNl7CfGBiJqr5hU+aQVvYIjAB2E5JZpKqtLAcwGcJhAEfuI1O90Kot/d/CHQV8sxMBaiLXDXjA6spK6XFEW/1XAHxCs+FNFUI5exUyrIT5g/oBUXNq5Lvz8yOXHr2HmOwC4BMvfx8wXJFNNvxRxdgRQgNra1lOlXG4HBBuHQG8z0/cSqYbXCtkFfdFLAamTwYcLBQrsKa9Mn7xmTeSAUUfnNbAArpw6H8K/TFrvyqlnaTU+AHR2Nz3GrJ4N4BWxujC5v7dSaDXRzIRF0XDlJc1V+8td1xLjPAY+C2C3CjzQ1R3ebKZchvolkU6SwNd3doebjfgkUk2/r69f9fX0u71rmYysIg7VSSw0Z1DyPYDf33ri/jLXK2AsY+C7AKYB8EnApoAv1j5jRsSMyP8m4sSgG4JyrB5g3eqpr19Vln5vXwMTakTqBEn/J+JW0gKIRCIS5XKPgnByHpPQMUdVLRAtn0lKCbqOZ8aqgC/+iCy3aL41hGqaj+19v/dlBi0HUCZQXz/lshsF/EpbALt3VPjA+HJBI+Yb9TTCSCSVho0AHhHxHcLnZvXpy6tvyztRFJJbpqmS60XNv6MAzFjasW7JX0R8S1oAkHCFDqtJLvAlYhUQV02qqgNhKYD3xMrAORm355lQqG38oV/U1raeqrK6FcCxgmW/xUT+ZCrcKuhfuq+Bc6qjn8266C/Q02USNiaUsKAIBpk1q618wuH9FxBIBpFX4JVt6wd9nos2b17QDwydF6DcdhBONFjOh8TYwGAlK52wyex5gpIVgN8bXUBEt+s0z2TJ83lFWfB3K+qW5ZZJLlW9jAjzAJyh35NWJrobF0UiEemN16qeJ+Zv6nRUQdjCwH3jKtKPi7zv543IqoJGm4Av9ksAX9Nrz0zXJVONd1kdR60vNktijoPoVB3mKkOdQeQ6C8xxnVVsUXPc0LW+aaeZOPNRkgKok5un5Nj1hhEfJryUVMJn2xHP3LmRcQd6q6JEfJ0O8z9hcK5Ca2Daz4yFyVT4HvMR5qckB4FZlgyfpCHG14PeFYb36elhzZrIgWSq8YdEWAiANcxPgHbjp0mlWXY3PlCSAmAikMhRKgIJ+emmUwnfDqKbTBaTUaF6O9c1PmtJUBqUnABCNdFzAHxBxJeZ6ozMzomQUBpuA7BBvAS+uat78VOWBaRByQlAlVx63v1HhnCy3xf9loXhjFQJu1TXfABp4654NUsnrLA+pvyUlACCwWUTyeRJWomla62KJx/t6xb1ELDSqB+pdMNo5wkoKQGoA56rdEzA/LzQl0yo8fubJ1sY1ohIqutu6NsBPMybnakGU6uXIpSMAGQ54iFmrV/vb8DSAhQeiZdRRvqBhaGNSPu6RT0A9Dco0UMAab1BWE7JCMClVl6rNW1KoLZEquE1ELYWLIyowe+PH2dheCPD3KHX0g2109ZY8lASAggGl00kwo0aZns9lb2DK3cqac34HYYM32JJcAUor+rbAOADTUPCC2uVpj/YHc9IlIQAMFD2U2juvad7h+fIe97tfQyMPxe0JlwelFt0TyWLMBTPOi07AvT2FJZT9AIIyC0XMaD1zO5FmeufC0Nbt0ayICzX8JFYVdfK8l2V5qMsUIlK92qYfODJuMzsOTBFUQtgTnX0s2D1QWisWRCwPJFY+JEtUT1706vB/HrBCghfcqkHDL+uGaFjXeNLAD9cwOTGNY8u0n5M2ETRCqC+flVZ1k0d0Dg+RaC3MyR9bEPE1q2RLEto0qqHiK8KeGPik0s66NnbdxUBrRjMEDrMXoDmJ7rDd9tZtxZFuhrIFPTGH2LCHG1LDiWVprwj6IAc2wLGeRrFZEDSJQml4QnDoRogGFw2kTPl0wnY33tg386NGyP/sLM+PRSlAAK+WDOAxZqGhEcTSrjgfni/v/VEyuZ+B+AzGqWlVRXndq0Lv6w/0tKnyB4BTAFvbAX0ND7wDty4WssomVz0RwJp2gGolCT8POiNjVnWzrGgaHqAWbPayidUDKwB4NdhrjLogmR34zN6yw/4omsBqtNhOsDE/1HosfJJoih6gNraFSdPqBh4DvoaHyD8p5HGBwCpvPxaADt0mHqIaW3AG1tWX79KZI9+STHmPUDQF5cZvBraqVWGuS/RHdbTpX8Mv795MmVd2zG4K0cH/GvVJYW6uhr/W6S+UmDMBBDwxk5hQpSAf9ftRNjY8/d0zdatkaxovSE5dprKeAHAJJ0ufQRq7u3vjRfDqN1qRl0AgcDKoymTvYmBehg7BrU13Z/+NysaYSiJ8yZovxkczF/A+HHPu+kOMwIsNkZNAEE59hVVRT0NvtsbPKpF67NEIUVp2G9VPAFvy1RA3QyC0VXBHgY9nCO6Y7Ry+dmJrQIIBFYeTdmsnxlzAHxFsJg7ppyeXhiJRFQrYwOAYE3sBCberHNP/6H0A3gMzO1VR4x/wq4sXnZjuQAuvjhyeMW4itkSUx0D50M8B0E/EZZ0KmG9p3+EuLz6tiMyrrJ2gC4yUcxeArqYuGMs7/8RwRIBRCIRafdrleewijlECACoMlnkG8wUTKYaRTNmGIQpKMevBlOriTQtAAbXJlQgwS48UApvD6YEEAq1jVcPDDSC8H0AVuyzY4BXp/v7GsZixB3wRqeDqBPAVCvKY8JLpKI5kQo/akV5diAsAL+/9UQpqz7H4OMtiuVFSaWGweXTsaO+flVZ73u98wHcDAP5/jV4aMrp6SvtGMeYRTABEtP0U7c/w2DTFxww8Adinp9IhRt3vH6OUJIDK/nNbx5Xd+566lfTz5h5L3IuN4CvQjyF2zBnvPd3z/s7dj0llMrNToR6gFrfigskSE+aqZiJtgG4Y/zEynXFPIKuq2k9RpWy8xhUD+AYE0W9k+gOiyaCsA0hAQTk2PVgLBNw7WWmRwDcNXoDPGuQ5YjHrVZ6QXQNwN+CwP/OpbomD20XLxqKYjGoVGDJ3LnCfldm1Pf9ayHaA5wPhtkDjNvBuDMrpVOKEhkwWZZtyHLL512cmze0p0Bvdu+R+OQ8AgCmgC/+MsRn9w4qCn8k4qWd3eGusTgZkw9ZbpnkZr4J4B/AWEbvEWHmHyVTTW0WhGYpgo8AYlLhxWC2C3MQTmRQwi/Ht/t98XNMl2cSWY54Ar7oQjerbwK8EBY0PoAHT5nWd6cF5ViOqWfalZc0V+0vc4VBuBrmRsjDMED3uQ9TF61d29RnQXmGCMorzmCWOgCcZlGRLxK4ubO76TGLyrOcYp0K3q2qarBr3eLfWhGfNkxBOb6AGc0Ays2UNDwVLHHu/s7U4jctCtA2LF8MmjMnWpHbT7MBhEwuBg2AaGlCaWyxMLyPEQjEjkQGnRiMVZS9BHSRSu1jPZNplFJYDr47S8cvsCNxwhw5elKWaTMAkUzbznKwEUxtCCE8moUUtHJDSG119HTJRZthPE1rD4FXZ6j8LqsST44lo74lbCjF648BzIehLWH8XLq/73tWrBKGalZ8U5WkTQA+lr83H4O3f+DGrHRcYrTTuNjJmG0KHUr2uAKA7hy+DDz+173pajN78gLelqkg9QUAE3W6pAlYliGp1coeqFgolm3hq6C7Qbg90R2+XGTSSJZbPl/GvF3vEjYTXnZDCrYrDf9jtK5Swewyp2l27Hpq15lTz39EBX0N0LNBk6afftpLvHPXU88ZqUeWl3/GzfQs9N3qrRJwa8/e9OUbNi3da6SeUmPMe4BhZDnicXPlGui7UlUl5gs7U01P6y0/4Iu1Q1+KuX4muiKpNHbpLbuUKRoBDMIU8MWXQ9/h0D0ow5cTibDmLzTgjdeBeK2OMtMg1CSU8BYdtp8Iimw5mDjRHV7CID03bk3mDN2nZTRHjp4EYj1p4nuZpZmfpsYHiq4HGMa6BBFBX+zpodvECjGgQr3Y7hy9stwyyQ31NDWHftUl7SyGt4oi6wGGIa48ouoqAJq/RomlZfkuhQp4oxfraHyA6So7G7++flVZ0Be/3c3qHjBekCT8ys3q2wFfzPaElVoUqQCA1avnZdw5rgNQ8GJkBh9fxuqiQz+vr19VBiIdiZfp3kSqsV04UB2k302vYfACfHSh6UgAdwXlqJ5LJmyjaAUAAGvXN/2NGHOhcQkDA9cHAiuPPviz9Pv75gHQ2rW8233Yx8VjJaGa+DeYOJjve2b66dzZrXqPxltOUQsAADpT4SeZNTN/VnEm+88LImfMiLiZaYmGj8os1dm970CVWCuXwYSBstxldsZQiKIXAABI5QM/AfBuIRsC6ufOjYwDgMlHVlVDY5GHmR5Mphp+bV2UH2coHq+WHZtMgW+GkhBAZ+fS9wH+Lw2zI/t7K2sBgKFqZRVPu1kye7WLJgf6qi6FnhwEjG/PkaMn2R3PSJSEAAAgS313g/HHgkbE19VWR08H6DsFzYCVo7E/n8B6f9mUhZR3nGAnJSMARYkMMGmNBeirkkvzMsnM0GUOtuL3N08GQ/+Rc+YrIpHIqLdHyQgAAHJEDxBIaz/AuRrfp0bldE7WdS2MpcD54huvVcyyK5x8lJQAFKXhPQaby99HsPz20EPx+5snE/Ajo37EtEyWHxnVFdqSEgAAgPCQsC/jfxNK4zYLoxmpEqKc6x4AFQLO01z89lKrIypEyQkgoTRuY0Dodg0ibrf79JHf1/ITMC4W9Sfg5oDcYiZdjSFKTgAAsSR2wwYbuMNHiIAcbyDwzSaLcYNVxe+La69hWEAJCgCQKGd47p4Jv7TroIYstxwW8EXvGboRXGuF9U8AtFYBKwm8ye+NX2v3TaclKYB2ZcluJhhL666SLQs+AW/0YjerrwA0T08UDHUOs+YFWADgIeI7g774ltrq+JfNxpkP0VM7Y4/K7SA6S6d1JieVWXYvjyy3TCoD1zLzfADTdTsyr0ymFr8QiUS27d5ZVQ3wtzVdgO9KLn4l6ItvUYnvHVeRfnz4ciwrKNINIdoMnS94B3pETNiYUMK6t5+PxKxZbeUTDu+/AERzAFwKo6eGCc9mkb5oOBeCLLcd5eaBbdC3SfVgPiTGBgYrWemETWbPKJSsAAAg6IttYkBz8oSJ/KKbPGU54injyjADYeg/S3Aov5PKPd/p6Fiw7+APh85GbIN4NrK3CHxjZ3dTUtC/NMcAwzDzGh1m7+VAgte5M7m5soOBWyHY+Ey0rSw3cN6hjQ8MjmXUHM/QuuOwAF9gUCLgizUK+pe2AKZM6+sG4dWCRkS3iu69C3jjlwLwifgOoYyr6D3v4fU35F3K7lrftDMrSWcDMJM061bRq3BLWgCRSER1g6vzTQwx0/1TpvYK3wtIQI2g64cAX5noDl+mZ8CmKA3vfNDnOZuB2wCIHHsrpywLTT6VtAAAYK3S9IccHTYdwBIQngbwewAKSJqVTDV+31R2TqKjtY1G8sPyRHfTg0ZcNm9e0D9+UlUEOq6aHRGGUKwlPQi0m4Av1gbghyK+DHqMylzzDr3RNG9dg3mKHwJwhkh9YAQTqXDCqFvJ9wB2IhHuASD0mkXgSzGQfXlwg0phAt7YbCLpRYg2PtCTlSShhNSOAArQoYR3EfE8CIoAhOMkF/3C74vOyGcSlOPXgNBtIk39h8xcLTrQdQSgQafSdL9E0pkAEtCewx+JzxBog98bP/PQL4K+WIiZ74LYKe29BGrLknpKMtUknITaGQMYIBRqG88DmRow1zEwE8Z+QD1Zyn5DUa5/GwACcvRcDOYnMjKjuB/ARivzEjkCECRU03ysSq6rQfgBBk/5aEN4fsrU9My3XvVMzLg8O6E/9exuAG1ZynYoyvUfCoacJyQHU8yd3Tqh35WLgLAAuv6fvAiDyTD05EHoA7C0Z2/6Z3ZdVecIwCKC3tiFTOiC9jmADPRtFt2tuugSu+8dcgRgIUOpZn8O8UWjYXagDOfqSX5hFkcAFhOsif0rS3gG4nst9rA7d1YyuWSPlXHlY8yTRH3S2PH6U3+aftqFwOBbglGYmL0JZXHhBS4LceYBbCBDvc0ARPYfJo0kvrICRwA2oCiRASK6zaAbg3GLLQEVwBGATXgqepPQONJ+CM8mUuE37IonH44AbGLNmsgBZta/EZXxsI3h5MURgI249B9E2Z+VsmNyvawjABvpWNe0HcBbOkwftXqKVy+OAGyFmKHdCzDZe2StEI4A7Mat3oPBOf18vJbDCU+MVjiH4gjAZpLJJXuYeRGAkfYm7gPx1WN5AYUzEzgK7Hx9y2+nn3r+dhAdA2ASgPcBbFBdriuSj5TWHcoODg4ODg4Onwz+H4uIjrDO3ZNoAAAAAElFTkSuQmCC"/>
                      </defs>
                    </svg>
                  </span>
                  <!-- card content -->
                  <div style="flex: 1 1 auto; min-width: 0;">
                    <h4 class="card-title">
                      <span class="card-title-text">
                        {{ item.titleKey | translate }}
                        <span
                          *ngIf="item.showInfo"
                          class="info-icon"
                          matTooltipPosition="above"
                          [matTooltip]="getSetupInfoKey(item) | translate"
                        >
                          ⓘ
                        </span>
                      </span>
                    </h4>
                    <p class="card-desc">{{ item.descKey | translate }}</p>
                  </div>
                </div>
                @if (phasesLoading) {
                  <div class="card-action-skeleton"></div>
                } @else {
                  @if (isItemDone(item)) {
                    <!-- Done Icon -->
                    <svg class="ms-[26px] min-[991px]:ms-0" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <rect width="32" height="32" rx="5" fill="#635CA8"/>
                      <path d="M10.3125 16.3997L13.9909 20.0781L22.0833 11.25" stroke="white" stroke-width="2.5001" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  } @else {
                    <!-- Complete Button -->
                    <button
                      class="ms-[26px] min-[991px]:ms-0"
                      type="button"
                      [class.complete-action-btn]="true"
                      [class.complete-btn]="item.actionType === 'complete'"
                      (click)="onAction(item)">
                      {{ item.actionKey | translate }}
                    </button>
                  }
                }
              </div>
            </div>
          </div>

          <!-- Mobile only: keep Sign up visible under left content -->
          <div *ngIf="allStepsCompleted" class="sign-up-btn-row-mobile">
            <button 
              mat-raised-button 
              color="primary" 
              type="button" 
              (click)="onClose()"
              class="sign-up-btn sign-up-btn--mobile">
              {{ 'SignUp' | translate }}
            </button>
          </div>
        </div>

        <div class="main-content-col main-content-right" fxFlex="100" fxFlex.gt-md="50">
          <div class="main-content-right-inner">
            <!-- Carousel (Tailwind) -->
            <div class="carousel-container relative w-full min-h-[320px] md:min-h-[400px] overflow-hidden rounded-xl">
              <div
                class="flex h-full min-h-[320px] md:min-h-[400px] transition-transform duration-300 ease-out"
                [style.transform]="factorTranslateValue(carouselIndex)"
              >
                <!-- [style.transform]="'translateX(-' + carouselIndex * 100 + '%)'" -->
                <div *ngFor="let slide of carouselSlides" class="min-w-full w-full h-full min-h-[320px] md:min-h-[400px] flex-shrink-0 flex items-center justify-center px-2 pb-[30px] pt-0">
                  <img class="ready-panorama-img w-full h-full object-contain" [src]="slide.imageSrc" [alt]="slide.imageName">
                </div>
              </div>
              <!-- Carousel dots -->
              <div class="absolute bottom-0 left-0 right-0 flex justify-center gap-2">
                <button
                  *ngFor="let slide of carouselSlides; let i = index"
                  type="button"
                  (click)="carouselIndex = i"
                  class="w-[18px] h-[18px] rounded-full transition-colors bg-[#CCCCCC]"
                  [class]="carouselIndex === i ? 'active-slide-point' : ''"
                  [attr.aria-label]="'Slide ' + (i + 1)"
                ></button>
              </div>
            </div>

            <div *ngIf="allStepsCompleted" class="sign-up-btn-row">
              <button 
                mat-raised-button 
                color="primary" 
                type="button" 
                (click)="onClose()"
                class="sign-up-btn">
                {{ 'SignUp' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
